import { createAsyncThunk } from "@reduxjs/toolkit"
import { RootState } from "@/core/app/store"
import { getPatientReport, getPatientCaseReport } from "./patientReport.service"

export const fetchPatientReport = createAsyncThunk(
  "patientReport/fetchPatientReport",
  async (patientId: string, { rejectWithValue, getState }) => {
    const orgId = (getState() as RootState).userService.user.current_orgId
    try {
      return await getPatientReport(orgId, patientId)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const fetchPatientCaseReport = createAsyncThunk(
  "patientReport/fetchPatientCaseReport",
  async (
    { patientId, caseId }: { patientId: string; caseId: string },
    { rejectWithValue, getState },
  ) => {
    const orgId = (getState() as RootState).userService.user.current_orgId
    try {
      return await getPatientCaseReport(orgId, patientId, caseId)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
